// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"367":"d1fca8a7","1868":"99e70971","5369":"9a32a17e","6591":"fb59f634","7853":"fb59f634"}[chunkId] + ".chunk.css";
};